require('isomorphic-fetch')

export const trackImpression = async referrer =>
  fetch(`/api/impressions`, {
    credentials: 'same-origin',
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({referrer})
  })
